import React from 'react';
import './Ticker.css';

const SKILLS = [
  { label: 'AWS', highlight: true },
  { label: 'Azure' },
  { label: 'GCP' },
  { label: 'Kubernetes', highlight: true },
  { label: 'ArgoCD' },
  { label: 'Terraform' },
  { label: 'Prometheus', highlight: true },
  { label: 'Grafana' },
  { label: 'Helm' },
  { label: 'EKS', highlight: true },
  { label: 'GitOps' },
  { label: 'Vertex AI' },
  { label: 'Loki', highlight: true },
  { label: 'Docker' },
  { label: 'Zscaler' },
  { label: 'OpenSearch', highlight: true },
  { label: 'WireGuard' },
  { label: 'Bitbucket' },
];

function Ticker() {
  const items = [...SKILLS, ...SKILLS];

  return (
    <div className="ticker-wrap">
      <div className="ticker">
        {items.map((item, i) => (
          <span key={i} className={`tick-item ${item.highlight ? 'lit' : ''}`}>
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Ticker;
